import script from "./aboutDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./aboutDetail.vue?vue&type=script&setup=true&lang=ts"

import "./aboutDetail.vue?vue&type=style&index=0&id=59f010ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59f010ba"]])

export default __exports__